import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

/**
 * Verifica si un usuario ya pertenece a una familia o completó el onboarding,
 * soportando todos los formatos de datos históricos y actuales de Firestore.
 */
export const checkUserHasFamily = (userData: any): boolean => {
  if (!userData) return false;
  if (userData.onboardingCompleted === true) return true;
  if (typeof userData.familyId === "string" && userData.familyId.trim().length > 0) return true;
  if (typeof userData.activeFamilyId === "string" && userData.activeFamilyId.trim().length > 0) return true;
  if (Array.isArray(userData.familyIds) && userData.familyIds.length > 0) return true;
  if (userData.familyIds && typeof userData.familyIds === "object" && Object.keys(userData.familyIds).length > 0) return true;
  return false;
};

/**
 * Busca si el usuario pertenece a alguna familia a través de la colección 'members',
 * como fallback si el documento en 'users' no tiene los campos de familyId poblados.
 */
export const findUserFamilyFallback = async (
  userId?: string | null,
  userEmail?: string | null
): Promise<string | null> => {
  if (!userId && !userEmail) return null;

  try {
    const membersRef = collection(db, "members");

    // 1. Buscar por userId
    if (userId) {
      const qUser = query(membersRef, where("userId", "==", userId));
      const snapUser = await getDocs(qUser);
      for (const docSnap of snapUser.docs) {
        const famId = docSnap.data()?.familyId;
        if (famId && typeof famId === "string" && famId.trim().length > 0) {
          return famId;
        }
      }
    }

    // 2. Buscar por email
    if (userEmail) {
      const qEmail = query(membersRef, where("email", "==", userEmail.toLowerCase().trim()));
      const snapEmail = await getDocs(qEmail);
      for (const docSnap of snapEmail.docs) {
        const famId = docSnap.data()?.familyId;
        if (famId && typeof famId === "string" && famId.trim().length > 0) {
          return famId;
        }
      }
    }
  } catch (err) {
    console.warn("Error en findUserFamilyFallback:", err);
  }

  return null;
};
